import React from "react"
import LandingSectionUnderline from "./LandingSectionUnderline"
import LandingReveal from "./LandingReveal"

type Props = {
  title: string
  description?: string
  eyebrow?: string
  underline?: boolean
  className?: string
}

const LandingSectionHeader: React.FC<Props> = ({
  title,
  description,
  eyebrow,
  underline = true,
  className = "",
}) => (
  <LandingReveal className={`mx-auto flex w-full max-w-3xl flex-col items-center gap-2 text-center ${className}`.trim()}>
    {eyebrow && (
      <p className="font-dm-sans text-xs font-semibold uppercase tracking-[0.22em] text-[#9e7e43]">
        {eyebrow}
      </p>
    )}
    <h2 className="font-outfit text-3xl font-semibold tracking-tight text-[#0d0d0d] md:text-4xl">
      {title}
    </h2>
    {description && (
      <p className="font-dm-sans text-base leading-7 tracking-wide text-[#5a5a5a]">{description}</p>
    )}
    {underline && <LandingSectionUnderline />}
  </LandingReveal>
)

export default LandingSectionHeader
